import React from 'react';
import { Box } from '@mui/material';
import avatarUser from '../../assets/images/avatar-user.png';
import avatarProfile from '../../assets/images/avatar-user-profile.png';
import avatarTerms from '../../assets/images/avatar-user-terms-of-use.png';
import { ModuleCard } from 'components/shared';
import { ROUTES } from 'routes/constants';
import ContainerPainel from 'components/container_painel';

const MenuUser: React.FC = () => {
  const cards = [
    {
      title: 'Usuários',
      description: 'Visualize e gerencie os usuários do sistema.',
      image: avatarUser,
      path: ROUTES.MANAGE_USER,
    },
    {
      title: 'Perfis de usuário',
      description: 'Visualize e gerencie os Perfis de Usuário disponíveis no sistema.',
      image: avatarProfile,
      path: null,
    },
    {
      title: 'Termos de Adesão Municipal',
      description: 'Gerencie os Termos de Adesão Municipal do sistema.',
      image: avatarTerms,
      path: ROUTES.TERMOFADHESION,
    },
  ];

  return (
    <ContainerPainel pagina="Gestão de Usuários">
      <Box
        sx={{
          backgroundColor: '#0048B6',
          height: '65px',
          alignContent: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#0048B6',
            height: '67px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '25px',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#FFFFFF',
              width: '90%',
              maxWidth: '1152px',
              borderRadius: '10px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              marginTop: '290px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              gap: '15px',
            }}
          >
            {cards.map((card, idx) => {
              const descriptionToShow = card.path ? card.description : 'Sem descrição';
              let badge = 'Em breve';
              switch (card.path) {
                case ROUTES.MANAGE_USER:
                  badge = 'Manage';
                  break;
                case ROUTES.TERMOFADHESION:
                  badge = 'Termos';
                  break;
                default:
                  badge = 'Em breve';
              }
              const highlight = card.path && card.title.includes('Usuários') ? 'highlight' : 'normal';

              return (
                <Box key={card.title} sx={{ width: '100%' }}>
                  <ModuleCard title={card.title} description={card.description} image={card.image} path={card.path} />
                  <Box component="span" sx={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)' }} aria-hidden>
                    <span data-testid={`badge-${idx}`}>{badge}</span>
                    <span data-testid={`desc-${idx}`}>{descriptionToShow}</span>
                    <span data-testid={`hl-${idx}`}>{highlight}</span>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </ContainerPainel>
  );
};

export default MenuUser;
